import React, { FC } from 'react';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import Grid from 'components/UI/Grid';
import { SystemSensorType } from 'models/systems';
import { theme } from 'components/UI';

const BooleanBody =
  (field: keyof SystemSensorType) => (data: SystemSensorType) => {
    return <BooleanBodyContainer data={!!data?.[field] as boolean | null} />;
  };

const BooleanBodyContainer: FC<{ data: boolean | null }> = observer((props) => {
  const { data } = props;

  return (
    <Grid align="center" justify="center">
      {data ? (
        <FontAwesomeIcon icon={faCheck} color={theme.color.success} />
      ) : (
        <FontAwesomeIcon icon={faTimes} color={theme.color.error} />
      )}
    </Grid>
  );
});

export { BooleanBody };
